module.exports = __webpack_public_path__ + "static/img/tu4.7c21267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jobs/tu4.png
// module id = Gaij
// module chunks = 1